import React from "react";
import "./HowWeWork.css";

import SearchIcon from "@mui/icons-material/Search";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import CodeIcon from "@mui/icons-material/Code";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const steps = [
  {
    step: "01",
    title: "Discovery",
    text: "Understand goals, scope, and roadmap.",
    icon: <SearchIcon />,
  },
  {
    step: "02",
    title: "Design",
    text: "UX, UI, and scalable architecture.",
    icon: <DesignServicesIcon />,
  },
  {
    step: "03",
    title: "Development",
    text: "Agile sprints with transparency.",
    icon: <CodeIcon />,
  },
  {
    step: "04",
    title: "Testing",
    text: "Security, performance & QA.",
    icon: <FactCheckIcon />,
  },
  {
    step: "05",
    title: "Launch",
    text: "Deployment & long-term support.",
    icon: <RocketLaunchIcon />,
  },
];

const HowWeWork = () => {
  return (
    <section className="oglitz-work-row">
      <div className="oglitz-work-header">
        <span className="oglitz-work-badge">Our Delivery Model</span>
        <h2>How We Work</h2>
        <p>
          A structured and scalable process designed to deliver predictable
          outcomes and long-term value.
        </p>
      </div>

      <div className="oglitz-work-steps">
        {steps.map((item, index) => (
          <div className="oglitz-work-step" key={index}>
            <div className="oglitz-work-step-no">{item.step}</div>
            <div className="oglitz-work-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowWeWork;
